// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_2EVcoYBBk0BAJGgUBw75HW","innerText":"_2EElLGxM3OFXdCmUI-O4cI","marketText":"yUCvpjzK49yZVoAP1TpZr","tickMark":"_1lN1w9-sV3XDKUDkimxqxn","oddsButton":"_8h6nOYQqfM_MKFTHV3V9B","checked":"_1Ybzl8JtGo-xzGEU-OZGZB","selected":"_2RJQoJGs6KsZWA13TX8xmX","buttonCustomStyle":"mS7rqP-j2ltKCJ3bkzXX2","customButtonContainer":"zEL_MTS_4yag0SqMDqevE","line":"PxaXq0HEu43nwzezNkiEP"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/basketball/css/oddsCard.css
// module id = 839
// module chunks = 0